<template>
  <div class="sec-kill" >
    <navigation
      :customClickEvent="true"
      @click="back"
      :style="{backgroundColor: transparent}"
      :theme="{
        background: 'transparent',
      }"
    >
      <span class="header-center">小美VIP·热门视频会员</span>
      <span
        slot="right"
        class="header-rule"
        @click="jumpRule('/secKill/rule')"
      > 规则</span>
    </navigation>
    <div class="shadow"></div>
    <section class="mian-fei">
      <div class="mian-title">
        <img src="./images/font_yue@2x.png"/>
        <div class="mian-select">10选1</div>
      </div>
      <div class="mian-big-img">
        <div v-for="(item,index) in bigImg" :key="index" class="mian-big-item">
          <img :src="item.img"/>
          <p class="mian-big-title">{{item.title}}</p>
          <p class="mian-big-content">{{item.content}}</p>
        </div>
      </div>
      <div class="mian-small-img">
        <div v-for="(item,index) in smallImg" :key="index" class="mian-small-item">
          <img :src="item.img"/>
          <p class="mian-small-title">{{item.title}}</p>
          <p class="mian-small-content">{{item.content}}</p>
        </div>
      </div>
      <div class="ling-qu" @click="draw">
        0元领取
      </div>
    </section>
    <section class="te-qaun">
      <div class="te-title">
        <img src="./images/font_xiao@2x.png"/>
        <div class="te-select">最高省11820元</div>
      </div>
      <div class="te-big-img">
        <div v-for="(item,index) in teBigImg" :key="index" class="te-big-item">
          <img :src="item.img"/>
          <div class="te-big-content">
            <p class="te-big-title">{{item.title}}</p>
            <p>{{item.content}}</p>
          </div>
        </div>
      </div>
      <div class="te-small-img">
        <div v-for="(item,index) in teSmallImg" :key="index" class="te-small-item">
          <img :src="item.img"/>
          <p class="te-small-title">{{item.title}}</p>
          <p class="te-small-content">{{item.content}}</p>
        </div>
      </div>
    </section>
    <nd-dialog
      v-model="dialog"
      :footer="false"
      closeBtn
      :isShowBg="true"
    >
      <div class="huang-guan"/>
      <div class="dialog">
        <p class="shen-ji">升级为小美VIP尊享版会员</p>
        <p class="shen-ji">即可免费领取</p>
        <nd-button class="open" @click="open">去开通</nd-button>
        <div class="xiang-xiang" @click="dialog=false">我再想想</div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { judgeClientSystem, getKey } from '../../../assets/utils'
import { mapActions, mapState } from 'vuex'
import qs from 'qs'

export default {
  name: 'sec-kill',
  customReadyNotify: true,
  data () {
    return {
      bigImg: [
        { img: require('./images/img_tengxun@2x.png'), title: '腾讯视频', content: '会员价 ¥ 0' },
        { img: require('./images/img_wangyiyun@2x.png'), title: '网易云音乐', content: '会员价 ¥ 0' }
      ],
      smallImg: [
        { img: require('./images/icon_vip_youku1@2x.png'), title: '优酷视频', content: '会员价 ¥ 0' },
        { img: require('./images/icon_vip_aiqiyi@2x.png'), title: '爱奇艺视频', content: '会员价 ¥ 0' },
        { img: require('./images/icon_vip_bili@2x.png'), title: 'B站会员', content: '会员价 ¥ 0' },
        { img: require('./images/icon_vip_mangguo@2x.png'), title: '芒果TV', content: '会员价 ¥ 0' },
        { img: require('./images/icon_vip_qq@2x.png'), title: 'QQ音乐', content: '会员价 ¥ 0' },
        { img: require('./images/icon_vip_youku@2x.png'), title: '酷狗音乐', content: '会员价 ¥ 0' },
        { img: require('./images/icon_vip_xima@2x.png'), title: '喜马拉雅FM', content: '会员价 ¥ 0' },
        { img: require('./images/icon_vip_elm@2x.png'), title: '饿了么', content: '会员价 ¥ 0' }
      ],
      teBigImg: [
        { img: require('./images/icon_tie@2x.png'), title: '提额机会', content: '最高1000元*6次' },
        { img: require('./images/icon_mianxi@2x.png'), title: '免息返现', content: '最高20元*6张' }
      ],
      teSmallImg: [
        { img: require('./images/icon_pei_yellow@2x.png'), title: '拒就赔', content: '最高1000元*6次' },
        { img: require('./images/icon_fangkuan_yellow@2x.png'), title: '优先放款', content: '审核提速90%' },
        { img: require('./images/icon_vip_shipin_yellow @2x.png'), title: '免费会员', content: '腾讯/爱奇艺' },
        { img: require('./images/icon_huafei_yellow@2x.png'), title: '话费折扣', content: '最高省120元' },
        { img: require('./images/icon_chuxing_yellow@2x.png'), title: '2折出行', content: '滴滴/哈罗单车' },
        { img: require('./images/icon_ka_yellow.png'), title: '0元省钱卡', content: `最高省10680` }
      ],
      dialog: false,
      submitBaseInfo: '', // 返回的橡树地址
      benefitType: '' // 调用获取token参数

    }
  },
  async created () {
    // await Promise.all([this.videoMemberUrlX()])
    this.$bus.$emit('ready')
  },
  computed: {
    ...mapState({
      statusBarHeight: state => state.statusBarHeight
    })
  },
  methods: {
    ...mapActions('vip', [
      'videoMemberUrl',
      'getLockAmount',
      'getToken'
    ]),
    back () {
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        return jsBridge('exit')
      } else {
        this.$router.go(-1)
      }
    },
    // 获取秒杀url
    async videoMemberUrlX () {
      let res = await this.videoMemberUrl()
      if (res.success) {
        let { url, benefitType } = res.data || {}
        this.submitBaseInfo = url
        this.benefitType = benefitType
      }
    },
    // 跳转
    jumpRule (url) {
      this.$router.push(url)
    },
    // 领取
    draw () {
      this.dialog = true
    },
    // 秒杀
    async open () {
      const origin = process.env.VUE_APP_PAYURL
      const token = getKey('userInfo', 'token') || ''
      const channel = getKey('channel') || ''
      const url = `${origin}/vip/svip?${qs.stringify({ token, channel })}`
      window.location.href = url
      // this.$router.push('/vip/svip')
      // const res = await this.getToken({
      //     benefitType: this.benefitType
      // })
      // if (res.success && res.data) {
      //     window.location.href = `${this.submitBaseInfo}&user_token=${res.data.jwtToken}&return_url=${encodeURIComponent(window.location.href)}`
      // }
    }
  }
}
</script>
<style scoped lang='less'>
@import "../../../assets/less/mixin.less";

.header-center{
  margin-left: 100px;
}
.shadow{
  position:absolute;
  top:100px;
  width:100%;
  height:130px;
  background:url('./images/bg_vip@2x.png');
  background-size:100% 100%;
  z-index:1;
}
.header{
  width: 100%;
  height:100px;
  background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
  position: fixed;
  top:0;
  z-index:3;
  padding:0 40px 0 30px;
  display: flex;
  align-items:center;
  justify-content:space-between;
  &-txt{
    height: 75px;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #763E12;
    line-height: 75px;
  }
  &-rule{
    height: 75px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #763E12;
    line-height: 75px;
    padding-right: 20px;
  }
  >img{
      height: 39px;
      width: 22px;
  }
}
.sec-kill{
  width: 750px;
  min-height: 100%;
  padding-bottom:88px;
  background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
  .rule-txt {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #763E12;
    line-height: 75px;
    padding: 0 40px;
  }
  .mian-fei{
    border:transparent;
    border-radius:20px;
    position: relative;
    z-index:2;
    width: 670px;
    margin:84px auto 0;
    padding-bottom:40px;
    background: #FFFFFF;
    box-shadow: inset 0px 3px 5px 0px #FFF4DA;
    border-radius: 20px;
    border-image: linear-gradient(180deg, rgba(255, 240, 229, 1), rgba(245, 203, 168, 1)) 2 2;
    .mian-title{
      width: 670px;
      height: 80px;
      background: linear-gradient(90deg, #FCD5AC 0%, #FEF6E4 100%);
      border-radius: 20px 20px 0px 0px;
      padding-left:250px;
      display: flex;
      align-items: center;
      >img{
        width:173px;
        height:49px;
      }
      .mian-select{
        display:inline-flex;
        padding:0 16px;
        height: 32px;
        background: linear-gradient(90deg, #EBAE6E 0%, #E6A758 100%);
        border-radius: 100px 100px 100px 0px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        align-items: center;
        justify-content:center;
        margin-left:7px;
      }
    }
    .mian-big-img{
      display:flex;
      flex-wrap: wrap;
      justify-content:space-between;
      padding:0 25px;
      margin:39px auto 14px;
      .mian-big-item{
        text-align: center;
        width: 300px;
        background: #FFF2E5;
        border-radius: 20px;
        padding-bottom:12px;
        >img{
          width:300px;
          height:170px;
        }
        .mian-big-title{
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763E12;
          line-height: 37px;
          padding-top:12px;
        }
        .mian-big-content{
          padding-top:4px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 33px;
        }
      }
    }
    .mian-small-img{
      display:flex;
      flex-wrap: wrap;
      .mian-small-item{
        text-align: center;
        flex:1 1 25%;
        margin-top:55px;
        >img{
          width:80px;
          height:80px;
        }
        .mian-small-title{
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763E12;
          line-height: 37px;
          padding-top:8px;
        }
        .mian-small-content{
          padding-top:4px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 33px;
        }
      }
    }
    .ling-qu{
      width: 580px;
      height: 88px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 47px;
      display: flex;
      align-items: center;
      justify-content:center;
      margin:52px auto 0;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 33px;
    }
  }
  .te-qaun{
    border:transparent;
    width: 670px;
    margin:84px auto 0;
    padding-bottom:50px;
    background: #FFFFFF;
    box-shadow: inset 0px 3px 5px 0px #FFF4DA;
    border-radius: 20px;
    border-image: linear-gradient(180deg, rgba(255, 240, 229, 1), rgba(245, 203, 168, 1)) 2 2;
    .te-title{
      width: 670px;
      height: 80px;
      background: linear-gradient(90deg, #FCD5AC 0%, #FEF6E4 100%);
      border-radius: 20px 20px 0px 0px;
      padding-left:48px;
      display: flex;
      align-items: center;
      >img{
        width:398px;
        height:49px;
      }
      .te-select{
        display:inline-flex;
        padding:0 16px;
        height: 32px;
        background: linear-gradient(90deg, #EBAE6E 0%, #E6A758 100%);
        border-radius: 100px 100px 100px 0px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        align-items: center;
        justify-content:center;
        margin-left:14px;
      }
    }
    .te-big-img{
      display:flex;
      flex-wrap: wrap;
      justify-content:space-between;
      padding:0 25px;
      margin:40px auto 0;
      .te-big-item{
        text-align: center;
        width: 300px;
        background: #FFF2E5;
        border-radius: 20px;
        padding-bottom:12px;
        display: flex;
        padding:20px 0 20px 20px;
        align-items: center;
        >img{
          width:70px;
          height:70px;
        }
        .te-big-content{
          display:flex;
          flex-direction:column;
          justify-content:space-between;
          padding-top:4px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          text-align: left;
          margin-left:18px;
          .te-big-title{
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #763E12;
            line-height: 37px;
          }
        }
      }
    }
    .te-small-img{
      display:flex;
      flex-wrap: wrap;
      .te-small-item{
        text-align: center;
        flex:1 1 33.3%;
        margin-top:47px;
        >img{
          width: 40px;
          height: 40px;
        }
        .te-small-title{
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763E12;
          line-height: 37px;
          padding-top:8px;
        }
        .te-small-content{
          padding-top:4px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 33px;
        }
      }
    }
  }
   .dialog{
    position: relative;
    background: linear-gradient(90deg, #FEF6E4 0%, #FCD5AC 100%);
    border-radius: 30px;
    text-align: center;
    padding:70px 0 42px;
  }
  .huang-guan{
    position: absolute;
    background: url('./images/img_0@2x.png');
    background-size:cover;
    width:420px;
    height:136px;
    top:-134px;
    left:106px;
  }
  .shen-ji{
    height: 90px;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #763E12;
    line-height: 45px;
  }
  .open{
    width: 440px;
    height: 74px;
    background: linear-gradient(270deg, #D79663 0%, #E4B378 100%);
    display:flex;
    align-items: center;
    justify-content: center;
    margin:auto;
  }
  .xiang-xiang{
    height: 33px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #763E12;
    line-height: 33px;
    margin-top:35px;
  }
}
</style>